import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { useExplorer } from "@/context/ExplorerContext";

const Paw = ({ filled, i }) => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden className="shrink-0" style={{ transform: `rotate(${i % 2 ? 14 : -14}deg) translateY(${i % 2 ? 1 : -1}px)`, opacity: filled ? 1 : 0.18, transition: "opacity .3s" }}>
    <g fill="currentColor">
      <ellipse cx="7" cy="8" rx="2.2" ry="2.8" />
      <ellipse cx="12" cy="6" rx="2.2" ry="2.8" />
      <ellipse cx="17" cy="8" rx="2.2" ry="2.8" />
      <path d="M12 11c-3.6 0-6.5 2.6-6.5 5.4 0 1.6 1.2 2.6 2.7 2.6 1.3 0 2.1-.6 3.8-.6s2.5.6 3.8.6c1.5 0 2.7-1 2.7-2.6C18.5 13.6 15.6 11 12 11z" />
    </g>
  </svg>
);

const COUNT = 26;

export const PawProgress = () => {
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, { stiffness: 80, damping: 24, mass: 0.4 });
  const [n, setN] = useState(0);
  const { t } = useExplorer();
  useEffect(() => smooth.on("change", (v) => setN(Math.round(v * COUNT))), [smooth]);
  return (
    <motion.div
      data-testid="paw-progress"
      role="progressbar"
      aria-label={t.progressLabel}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round((n / COUNT) * 100)}
      className="pointer-events-none fixed inset-x-0 top-0 z-50 flex h-8 items-center justify-between px-4 text-blue sm:px-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.2 }}
    >
      {Array.from({ length: COUNT }).map((_, i) => (
        <Paw key={i} i={i} filled={i < n} />
      ))}
    </motion.div>
  );
};
